import { CreateGroupModal as SharedCreateGroupModal } from '@valiant/ui-shared'
import { useGetLiquidityProvidersQuery, useCreateGroupMutation } from '@/generated/graphql'

interface CreateGroupModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function CreateGroupModal({ open, onOpenChange }: CreateGroupModalProps) {
  const [{ data }] = useGetLiquidityProvidersQuery()
  const [, createGroup] = useCreateGroupMutation()

  return (
    <SharedCreateGroupModal
      open={open}
      onOpenChange={onOpenChange}
      liquidityProviders={data?.getLiquidityProviders || []}
      onCreateGroup={createGroup}
    />
  )
}
